import * as Sentry from "@sentry/react";

export const initSentry = () => {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    console.warn("Sentry DSN not found in environment variables");
    return;
  }

  Sentry.init({
    dsn,
    integrations: [
      new Sentry.BrowserTracing({
        // Set tracing origins to connect traces between frontend and backend
        tracePropagationTargets: [
          "localhost",
          "127.0.0.1",
          /^https:\/\/api\.workinger\.eu/,
          /^https:\/\/app\.workinger\.eu/
        ]
      })
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of transactions for performance monitoring
    // Session Replay
    replaysSessionSampleRate: 0.1, // 10% of sessions will be recorded
    replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors will be recorded
    environment: import.meta.env.VITE_ENVIRONMENT || "development",
    release: import.meta.env.VITE_RELEASE_VERSION || "1.0.0"
  });
};
